<template>
  <div v-if="type === 'success'" class="ms-MessageBar ms-MessageBar--success">
    <div class="ms-MessageBar-content">
      <div class="ms-MessageBar-icon">
        <i class="ms-Icon ms-Icon--Completed"></i>
      </div>
      <div class="ms-MessageBar-text">
        <slot />
      </div>
    </div>
  </div>
  <div v-else-if="type === 'error'" class="ms-MessageBar ms-MessageBar--error">
    <div class="ms-MessageBar-content">
      <div class="ms-MessageBar-icon">
        <i class="ms-Icon ms-Icon--ErrorBadge"></i>
      </div>
      <div class="ms-MessageBar-text">
        <slot />
      </div>
    </div>
  </div>
  <div v-else-if="type === 'warning'" class="ms-MessageBar ms-MessageBar--warning">
    <div class="ms-MessageBar-content">
      <div class="ms-MessageBar-icon">
        <i class="ms-Icon ms-Icon--Info"></i>
      </div>
      <div class="ms-MessageBar-text">
        <slot />
      </div>
    </div>
  </div>
  <div v-else class="ms-MessageBar">
    <div class="ms-MessageBar-content">
      <div class="ms-MessageBar-icon">
        <i class="ms-Icon ms-Icon--Info"></i>
      </div>
      <div class="ms-MessageBar-text">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: ''
    }
  }
};
</script>
